import { postGetAttributeDataList } from "../../request/bsplatform/attributeDefinition/getAttributeDataList/post.js";
import { reqDelivery } from "../../request/bsplatform/carrier/delivery/method/post.js";
import { getGetMarketLineAttributeColumn } from "../../request/bsplatform/commodity/getMarketLineAttributeColumn/get.js";
function getUnifySelectInventoryDeliveryMethodsOptions({
  list,
  records,
  batchDeliveryMethods
}) {
  console.log("getUnifySelectInventoryDeliveryMethodsOptions\u53C2\u6570", JSON.stringify({ list, records, batchDeliveryMethods }));
  const ret = (list || []).concat(records).map(({ value }) => value).reduce((options, value) => {
    if (options.exclude) {
      if (value.startsWith("\u4E00\u4EF6\u4EE3\u53D1")) {
        options.push(value);
      }
    } else if (!(options.exclude = value.startsWith("\u4E00\u4EF6\u4EE3\u53D1"))) {
      options.push(value);
    } else {
      options.splice(0, options.length, value);
    }
    return options;
  }, []);
  if (batchDeliveryMethods && batchDeliveryMethods.length) {
    return ret.filter((value) => value.startsWith("\u4E00\u4EF6\u4EE3\u53D1") || batchDeliveryMethods.includes(value));
  }
  return ret;
}
async function getUnifySelectInventoryDeliveryMethodsRecords({
  getAttributeDataList,
  productId,
  attributeId,
  customOptions
}) {
  var _a, _b, _c;
  console.log("getUnifySelectInventoryDeliveryMethodsRecords\u53C2\u6570", JSON.stringify({ productId, attributeId, customOptions }));
  const innerGetAttributeDataList = getAttributeDataList || postGetAttributeDataList;
  const { status, data } = await innerGetAttributeDataList({
    productId,
    attributeId
  });
  if (status) {
    if (customOptions) {
      return (_b = (_a = data == null ? void 0 : data.dataList) == null ? void 0 : _a.records) == null ? void 0 : _b.filter(({ value }) => customOptions.includes(value));
    } else {
      return (_c = data == null ? void 0 : data.dataList) == null ? void 0 : _c.records;
    }
  } else {
    return [];
  }
}
async function getUnifySelectInventoryDeliveryMethodsBatchDeliveryMethods({ destinationRegion }) {
  console.log(`getUnifySelectInventoryDeliveryMethodsBatchDeliveryMethods\u53C2\u6570`, JSON.stringify({ destinationRegion }));
  const [...data] = await reqDelivery({ destinationRegion });
  if (!data.includes("\u7ECF\u9500\u5546\u81EA\u63D0")) {
    data.unshift("\u7ECF\u9500\u5546\u81EA\u63D0");
  }
  return data;
}
async function getConfigAttributeList(productType, marketClassify) {
  console.log(`getConfigAttributeList\u53C2\u6570`, JSON.stringify({ productType, marketClassify }));
  const res = await getGetMarketLineAttributeColumn({ productType, marketClassify });
  if (res.data && res.data.length > 0) {
    return res.data.map((item) => {
      return {
        attributeId: item.attributeId,
        inputType: item.inputType,
        attributeCode: item.attributeCode,
        options: []
      };
    });
  } else {
    return [];
  }
}
function getFaucetModelDisplayName(attributeCode, attributeDisplayValues, configAttributeList) {
  let displayName = attributeDisplayValues;
  if (!Array.isArray(attributeDisplayValues) || attributeDisplayValues.length === 0) {
    return displayName;
  }
  configAttributeList.forEach((item) => {
    if (item.attributeCode === attributeCode && Array.isArray(item.options)) {
      item.options.forEach((it) => {
        if (it.value === attributeDisplayValues[0]) {
          displayName = [it.displayName];
        }
      });
    }
  });
  return displayName;
}
function getAttributeValue(data, returnAttributes = [], configAttributeList) {
  const editableAttributeColumn = [];
  const editableAttributeValue = [];
  const attributes = [];
  data = data || [];
  data.forEach((item) => {
    if (item.allowEdit || item.attributeCode === "isSelectFaucet" || item.attributeCode === "isNonStand") {
      if (item.allowEdit) {
        const column = {
          attributeCode: item.attributeCode,
          attributeName: item.attributeName
        };
        try {
          const { customOptions } = JSON.parse(item.ruleExpression || "{}");
          Object.assign(column, { customOptions });
        } catch (e) {
          console.log(e);
        }
        editableAttributeColumn.push(column);
      }
      if (item.attributeCode === "faucetModel") {
        editableAttributeValue.push({
          attributeCode: item.attributeCode,
          attributeValues: item.attributeValues,
          attributeDisplayValues: getFaucetModelDisplayName(item.attributeCode, item.attributeDisplayValues || [], configAttributeList),
          attributeId: item.attributeId,
          mustEdit: item.mustEdit
        });
      } else {
        editableAttributeValue.push({
          attributeCode: item.attributeCode,
          attributeValues: item.attributeValues,
          attributeId: item.attributeId,
          mustEdit: item.mustEdit
        });
      }
    }
    if (returnAttributes.some((it) => it === item.attributeCode)) {
      attributes.push({
        attributeCode: item.attributeCode,
        attributeValues: item.attributeValues
      });
    }
  });
  return { editableAttributeColumn, editableAttributeValue, attributes };
}
export { getAttributeValue, getConfigAttributeList, getUnifySelectInventoryDeliveryMethodsBatchDeliveryMethods, getUnifySelectInventoryDeliveryMethodsOptions, getUnifySelectInventoryDeliveryMethodsRecords };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/business/unifySelectInventory/deliveryMethod.js